// v17-R1 D4: alle schermen met autosave melden hier een flush aan; de herlaadbalk wacht daarop vóór het herladen.
const fns = new Set();

export const registerFlush = (fn) => {
  fns.add(fn);
  return () => fns.delete(fn);
};

export const flushAlles = (maxMs = 8000) =>
  Promise.race([
    Promise.allSettled([...fns].map((f) => Promise.resolve().then(f))),
    new Promise((r) => setTimeout(r, maxMs)),
  ]);

export const wacht = (ms) => new Promise((r) => setTimeout(r, ms));
